import { faExclamation } from "@fortawesome/pro-solid-svg-icons";

import { UISubscriptionStatus } from "common/types";
import { Optional } from "common/utils/types";

import Status from "client/common/components/content/Status";

import { SubscriptionPaymentMethod } from "../types";
import { shouldShowSubscriptionPaymentAlert } from "../utils";

type SubscriptionPaymentWarningIconProps = {
  subscription: {
    visible_status: UISubscriptionStatus;
    payment_method: Optional<SubscriptionPaymentMethod>;
  };
};

/**
 * Points at the payment method field rather than the Autoship as a whole, so the client can
 * see which one needs attention. The banner alongside it names the problem.
 */
const SubscriptionPaymentWarningIcon = ({ subscription }: SubscriptionPaymentWarningIconProps) => {
  if (!shouldShowSubscriptionPaymentAlert(subscription)) {
    return null;
  }
  return <Status.Icon color="danger" icon={faExclamation} />;
};

export default SubscriptionPaymentWarningIcon;
